import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import ActionAdd from '../../store/action/FlowTemplate/Add'
import ActionEdit from '../../store/action/DivisionSetting/Edit'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from '../../store/action/Division/FetchAll';
import ActionGetAllSender from '../../store/action/Sender/FetchAll';
import ActionUploadFile from '../../store/action/FlowTemplate/Upload';
class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: fromJS({
                'flow-id': '',
                "selected-file": null,
            }),
            disabled: false,
            errors: fromJS({}),
            error: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.setState({
            form: fromJS({
                'flow-id': this.props.item.get('flow_id')
            }),
        })
    }

    handleChange(field, value) {
        var formVal = this.state.form;
        formVal = formVal.set(field, value);

        if (field === 'client-id') {
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value, 'List Upload');
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ form: formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ form: formVal })
    }
    handleOnFileChanged(event) {
        let newForm = this.state.form;
        newForm = newForm.set("selected-file", event.target.files[0]);
        this.setState({
          form: newForm
        })
    }
    async handleUpload() {
        var file = this.state.form.get('selected-file');
        var flow_id = this.state.form.get('flow-id');
        var response = await this.props.actionUploadFile(file,flow_id);
        if (response.get('success')) {
            toast.success('Success Upload File Flow!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        }else {
        // toast.error('Upload Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    componentWillMount() {
        this.setState({
            form: fromJS({
                'flow-id': this.props.item.get('flow_id')
            }),
        })
    }

    render() {
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">File Upload</span>
                        <div className="col-sm-10">
                            <input className="form-control" type="file" name="file" onChange={this.handleOnFileChanged} />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                value="Cancel"
                                onClick={this.handleCancel}>
                                Cancel
                            </button>
                            <button type="button"
                                className="btn btn-wide btn-success"
                                onClick={this.handleUpload}>
                                Upload
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionEdit: ActionEdit,
        actionUploadFile: ActionUploadFile,
    }, dispatch),
)(Form);